export * from './stat/stat.module';
export * from './page-header/page-header.module';



// WEBPACK FOOTER //
// ./src/app/shared/modules/index.ts